import React from 'react';
import TeamItems from '../TeamItems/TeamItems';
import TeamTitle from '../TeamTitle/TeamTitle';
import classes from "./Team.module.css";

export default function Team() {
  return (
    <section className={classes.team} id="team">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <TeamTitle />
          </div>
          <TeamItems />
        </div>
        <div className={classes.frame}>
        <svg width="156" height="71" viewBox="0 0 156 71" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.92578 66.9842C54.4047 47.1991 105.192 25.6692 154.074 2.48486C120.855 25.9721 82.8804 46.5798 41.1366 63.7737C78.8244 55.8914 112.382 41.9856 145.516 28.2289C129.239 41.3255 110.898 53.3385 90.7745 64.0818L142.344 49.351C138.879 55.733 132.582 61.3478 124.207 65.5231L145.971 59.6288L139.91 68.515" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      </div>
    </section>
  )
}
